import type { ReactNode } from "react";
import { Container } from "@/components/ui/container";
import { cn } from "@/lib/utils";

export function LandingSection({
  id,
  eyebrow,
  title,
  sub,
  dense,
  children,
  className,
}: {
  id?: string;
  eyebrow?: string;
  title?: ReactNode;
  sub?: ReactNode;
  dense?: boolean;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section
      id={id}
      className={cn(
        "relative border-t border-white/[0.05]",
        dense ? "py-16" : "py-[120px]",
        className,
      )}
    >
      <Container>
        {(eyebrow || title || sub) && (
          <header className="max-w-[760px] mb-14">
            {eyebrow && (
              <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] font-semibold text-[var(--brand)] mb-4">
                <span aria-hidden="true" className="block h-px w-[18px] bg-[var(--brand)]" />
                {eyebrow}
              </div>
            )}
            {title && (
              <h2 className="text-balance font-medium text-white leading-[1.05] tracking-[-0.02em] text-[clamp(32px,4vw,52px)] m-0">
                {title}
              </h2>
            )}
            {sub && (
              <p className="text-pretty mt-4 max-w-[620px] text-[17px] leading-[1.55] text-[var(--fg-dim)]">
                {sub}
              </p>
            )}
          </header>
        )}
        {children}
      </Container>
    </section>
  );
}
